module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 header"
  }, [_c('router-link', {
    staticClass: "back-link material-icons",
    attrs: {
      "to": "/recipes"
    }
  }, [_vm._v("chevron_left")]), _vm._v(" "), (!_vm.editMode) ? _c('i', {
    staticClass: "material-icons add-link",
    on: {
      "click": function($event) {
        _vm.changeEditMode()
      }
    }
  }, [_vm._v("edit_mode")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('i', {
    staticClass: "material-icons add-link",
    on: {
      "click": function($event) {
        _vm.changeEditMode()
      }
    }
  }, [_vm._v("done")]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.recipe.title))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 list"
  }, [_c('ul', _vm._l((_vm.recipe.ingredients), function(ingredient, index) {
    return _c('li', {
      staticClass: "list-item"
    }, [_vm._v(_vm._s(ingredient.quantity) + " " + _vm._s(ingredient.name) + "\n\t\t\t"), (_vm.editMode) ? _c('i', {
      staticClass: "material-icons pull-right",
      on: {
        "click": function($event) {
          _vm.deleteIngredient(index)
        }
      }
    }, [_vm._v("close")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('i', {
      staticClass: "material-icons pull-right item-increase",
      on: {
        "click": function($event) {
          _vm.increaseIngredient(index)
        }
      }
    }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('i', {
      staticClass: "material-icons pull-right item-decrease",
      on: {
        "click": function($event) {
          _vm.decreaseIngredient(index)
        }
      }
    }, [_vm._v("remove")]) : _vm._e()])
  })), _vm._v(" "), (!_vm.editMode) ? _c('button', {
    staticClass: "mdl-button mdl-button--raised",
    on: {
      "click": function($event) {
        _vm.addMeal(_vm.recipe)
      }
    }
  }, [_vm._v("Add to Meal Plan")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('router-link', {
    staticClass: "mdl-button mdl-button--raised",
    attrs: {
      "tag": "button",
      "to": _vm.$route.params.id + '/edit'
    }
  }, [_vm._v("\n\t\tAdd Ingredients")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2ac2696"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recipe.vue
// module id = 142
// module chunks = 0